import React, { useState } from "react";
import axios from "axios";
import { Loader2, Lock, Check, Eye, EyeOff } from "lucide-react";
import { API, inputCls, btnPrimary } from "./crm/shared";

export const ChangePasswordCard = ({ headers }) => {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const strong = /[A-Z]/.test(form.next) && /[a-z]/.test(form.next) && /\d/.test(form.next) && form.next.length >= 8;
  const canSubmit = form.current && strong && form.next === form.confirm && form.next !== form.current && !busy;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg(""); setError("");
    try {
      await axios.post(`${API}/auth/me/change-password`, { current_password: form.current, new_password: form.next }, { headers });
      setMsg("Contraseña actualizada correctamente. Te enviamos una confirmación por correo.");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "No se pudo cambiar la contraseña");
    } finally { setBusy(false); }
  };

  const type = show ? "text" : "password";
  return (
    <form data-testid="change-password-card" onSubmit={submit} className="bg-white border border-black/[0.06] rounded-2xl p-5 sm:p-6 mb-4">
      <div className="flex items-start gap-3 mb-5">
        <div className="w-10 h-10 rounded-xl bg-black flex items-center justify-center shrink-0"><Lock size={18} className="text-[#0fe814]" /></div>
        <div>
          <h2 className="text-[16px] font-extrabold text-black">Cambiar contraseña</h2>
          <p className="text-[12px] font-medium text-black/50">Debes ingresar tu contraseña actual. La nueva debe tener al menos 8 caracteres con mayúsculas, minúsculas y números.</p>
        </div>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        <input data-testid="pwd-current" type={type} autoComplete="current-password" placeholder="Contraseña actual" className={inputCls} value={form.current} onChange={set("current")} />
        <input data-testid="pwd-new" type={type} autoComplete="new-password" placeholder="Nueva contraseña" className={inputCls} value={form.next} onChange={set("next")} />
        <input data-testid="pwd-confirm" type={type} autoComplete="new-password" placeholder="Confirmar nueva contraseña" className={inputCls} value={form.confirm} onChange={set("confirm")} />
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <button type="submit" data-testid="pwd-submit" className={btnPrimary} disabled={!canSubmit}>{busy ? <Loader2 size={13} className="animate-spin" /> : <Check size={13} />} Guardar nueva contraseña</button>
        <button type="button" data-testid="pwd-toggle" onClick={() => setShow((s) => !s)} className="inline-flex items-center gap-1.5 text-[12px] font-bold text-black/55 hover:text-black">{show ? <EyeOff size={13} /> : <Eye size={13} />} {show ? "Ocultar" : "Mostrar"}</button>
        {form.next && !strong && <span className="text-[11px] font-bold text-[#ff603e]">Falta: 8+ caracteres, mayúscula, minúscula y número</span>}
        {form.confirm && form.next !== form.confirm && <span className="text-[11px] font-bold text-[#ff603e]">Las contraseñas no coinciden</span>}
        {msg && <span data-testid="pwd-msg" className="text-[12px] font-bold text-[#0fb013]">{msg}</span>}
        {error && <span data-testid="pwd-error" className="text-[12px] font-bold text-[#ff603e]">{error}</span>}
      </div>
    </form>
  );
};

export default ChangePasswordCard;
